import { Component, ElementRef, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserSummary } from '~/models/administration/user';
import { LabelService } from '~/services/modules/stocks/labels';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';

import { LabelType } from '~/shared/enums/label-type.enum';

@Component({
    selector: 'app-copy-barcode-label',
    templateUrl: './copy-barcode-label.component.html',
    styleUrls: ['./copy-barcode-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CopyBarcodeLabelComponent implements OnInit {

  _theme: string;
  _popupSub!: Subscription;
  _active: boolean = true;
  _form: FormGroup;

  id: number;
  _pageName: string = '';
  labelType?: LabelType;

  isAdmin: boolean;

  _currentUser: UserSummary;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  constructor(private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _sharedService: SharedService,
    private _fb: FormBuilder,
    private _securityService: SecurityService,
    private _labelsService: LabelService,
    @Inject(PORTAL_DATA) public data: any) {
    this._form = this._fb.group({
      name: new FormControl(''),
    });

    this._themeManager.themeChange.subscribe((data: any) => {
      this._theme = data;
    });

    if (data) {
      if (data.model?.id)
        this.id = data.model.id;
      else if (data.id)
        this.id = data.id;

      this.labelType = data.labelType ?? data.model?.labelType;
    }
    this._currentUser = this._securityService.currentUser;
    this.isAdmin = this._currentUser.appRole.name === "Admin";
  }

  ngAfterViewInit(): void {

  }
  ngOnDestroy(): void {
    if (this._popupSub) this._popupSub.unsubscribe();
  }
  _initForm() {
    this._form = this._fb.group({
      name: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this._initForm();
  }

  _closeForm() {
    this._active = false;
    var closeComponent = {
      //response: response,
      component: 'copy-barcode-label',
      isClosed: true
    }
    this._active = false;
    //this._gridLayoutManagerService.setGridDataSubjects('users');
    // this._layoutManager.setFromChanged('users');
    //this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
  }
  _onStateChanges(e: any) {
    // var element: any = this.kendoMainWindow;
    // if (e === 'minimized') {
    //   element.el.nativeElement.classList.remove('fullWidthFormForm');
    // } else if (e === 'maximized') {
    //   element.el.nativeElement.classList.remove('fullWidthFormForm');
    // } else if (e === 'default') {
    //   element.el.nativeElement.classList.add('fullWidthFormForm');
    // }
  }

  _copySubscription!: Subscription;
  _onSave() {

    let model: any = {
      id: this.id,
      name: this._form.value.name,
    }
    if (this._copySubscription) this._copySubscription.unsubscribe();
    this._copySubscription = this._labelsService
      .copyLabelPreset(model)

      .subscribe((data: any) => {
        if (data.message) {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: data.message,
            withoutConfirm: true
          });
          if (data.extraData && this.labelType) {
            data.extraData.labelType = this.labelType;
          }
          this._labelsService.labelAdded.emit(data.extraData);
          this._closeForm();
        }
        else {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: 'Error.',
            withoutConfirm: true
          });
        }


      },
        (error: any) => {


          this._layoutComponent.openPopup({
            title: 'Alert',
            message: 'Error.',
            withoutConfirm: true
          });
        });
    //this._popupSub.unsubscribe();
  }





}
